__turbopack_context__.v({
  "button": "back-to-top-button-module-scss-module__tVY7qW__button",
  "placeholder": "back-to-top-button-module-scss-module__tVY7qW__placeholder",
  "visible": "back-to-top-button-module-scss-module__tVY7qW__visible",
});
